import { createRoute } from '@tanstack/react-router';
import { Masthead } from '@/components/Masthead';
import { ReturnButton } from '@/components/ReturnButton';
import { useT } from '@/i18n';
import { parseHandoffParams } from '@/lib/handoff';
import { Route as rootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/not-found',
  component: NotFoundPage,
});

function NotFoundPage() {
  const t = useT();
  const { returnUrl, embed, parentOrigin } = parseHandoffParams(window.location.search);
  return (
    <div className="flex flex-1 flex-col">
      <Masthead />
      <main className="mx-auto flex max-w-md flex-1 flex-col items-center justify-center gap-5 px-6 pb-16 text-center">
        <span
          aria-hidden
          className="flex h-16 w-16 items-center justify-center rounded-full bg-paper-2 text-3xl text-ink-faint ring-1 ring-line-strong"
        >
          ∅
        </span>
        <div>
          <h1 className="hb-title text-3xl">{t('This link is invalid or expired')}</h1>
          <p className="mt-3 text-ink-soft">{t('Return to FixIt to continue')}</p>
        </div>
        <ReturnButton
          returnUrl={returnUrl}
          embed={embed}
          parentOrigin={parentOrigin}
          variant="primary"
        />
      </main>
    </div>
  );
}
